var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralOutdoorRH = function SvgDAhuGeneralOutdoorRH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 294,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,284c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S157.5,284,163,284 M163,283c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S169.1,283,163,283L163,283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.3,294.1h-1.1v2.2h-1v-5.7h2c0.7,0,1.2,0.1,1.5,0.4s0.5,0.7,0.5,1.3c0,0.4-0.1,0.7-0.3,1s-0.4,0.5-0.8,0.6l1.3,2.4 v0h-1.1L160.3,294.1L160.3,294.1z M159.2,293.4h1c0.3,0,0.6-0.1,0.8-0.2s0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7 c-0.2-0.2-0.4-0.2-0.8-0.3h-1L159.2,293.4L159.2,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,296.3h-1v-2.5h-2.5v2.5h-1v-5.7h1v2.4h2.5v-2.4h1V296.3z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 305,
    width: 2,
    height: 22
  })))));
};
export default SvgDAhuGeneralOutdoorRH;